import React from 'react';
import { Shield, Award, Clock, Users } from 'lucide-react';
const AboutSection = () => {
  return <section id="about-section" className="py-16 md:py-24 bg-white" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <div className="flex flex-col md:flex-row gap-12" data-id="element-21">
          {/* Left side image */}
          <div className="w-full md:w-1/2" data-id="element-22">
            <div className="relative" data-id="element-23">
              <img src="https://images.unsplash.com/photo-1600132806370-bf17e65e942f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2094&q=80" alt="I75 Audio & Video, LLC technicians installing home theater system" className="w-full h-auto rounded-xl shadow-lg object-cover" style={{
              maxHeight: '500px'
            }} data-id="element-24" />
              <div className="absolute -bottom-8 -right-8 bg-blue-600 rounded-lg p-6 shadow-xl hidden md:block" data-id="element-25">
                <div className="text-white text-center" data-id="element-26">
                  <p className="text-4xl font-bold" data-id="element-27">20+</p>
                  <p className="text-sm uppercase tracking-wider" data-id="element-28">
                    Years Experience
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Right side content */}
          <div className="w-full md:w-1/2" data-id="element-29">
            <div className="md:pl-6" data-id="element-30">
              <p className="text-blue-600 font-semibold mb-2" data-id="element-31">
                ABOUT OUR COMPANY
              </p>
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-32">
                Southwest Florida's Premier AV & Smart Home Solutions Provider
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-33">
                With over two decades of technology experience, Owner Chris Zino
                has navigated the industry's evolution from dial-up internet to
                fiber networks and beyond. Prior to founding i75 Audio & Video
                LLC in 2003, Chris worked in IT for a major Northeast cable
                company and brings extensive construction industry knowledge
                from his family background. This unique combination of technical
                expertise and project management experience enables i75 Audio &
                Video to deliver comprehensive technology solutions for both
                residential and commercial clients.
              </p>
              <p className="text-gray-600 mb-6" data-id="element-34">
                Let i75 Audio & Video help you or your business achieve all your
                technology needs.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-35">
                {[{
                icon: <Shield className="w-5 h-5" data-id="element-36" />,
                title: 'Licensed & Insured',
                desc: 'Full coverage for your peace of mind'
              }, {
                icon: <Award className="w-5 h-5" data-id="element-37" />,
                title: 'Certified Experts',
                desc: 'Factory-trained technicians'
              }, {
                icon: <Clock className="w-5 h-5" data-id="element-38" />,
                title: 'Prompt Service',
                desc: 'On-time arrivals guaranteed'
              }, {
                icon: <Users className="w-5 h-5" data-id="element-39" />,
                title: 'Local Team',
                desc: 'Southwest Florida based'
              }].map((item, idx) => <div key={idx} className="flex items-start" data-id="element-40">
                    <div className="mr-4 bg-blue-100 p-3 rounded-full text-blue-600" data-id="element-41">
                      {item.icon}
                    </div>
                    <div data-id="element-42">
                      <h3 className="font-semibold text-gray-800" data-id="element-43">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 text-sm" data-id="element-44">{item.desc}</p>
                    </div>
                  </div>)}
              </div>
              <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300 inline-flex items-center" onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }} data-id="element-45">
                Get Your Free Quote Today
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-46">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-47" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default AboutSection;